// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const togedemaru: PokeData = {
  "id": 777,
  "name": "togedemaru",
  "height": 3,
  "weight": 33,
  "base_experience": 152,
  "types": [
    PokeType.ELECTRIC,
    PokeType.STEEL
  ],
  "api_moves": [
    "tackle",
    "pin-missile",
    "thunder-shock",
    "defense-curl",
    "rollout",
    "spark",
    "charge",
    "magnet-rise",
    "discharge",
    "wild-charge",
    "fell-stinger",
    "spiky-shield",
    "electric-terrain",
    "nuzzle",
    "zing-zap"
  ],
  "moves": [
    "tackle",
    "pin-missile",
    "thunder-shock",
    "wild-charge",
    "electric-terrain",
    "iron-defense",
    "thunder-punch",
    "zap-cannon",
    "metal-sound",
    "meteor-mash",
    "quick-tempo",
    "metal-rush",
    "magnet-bomb"
  ],
  "evolution_chain": {
    "id": 403,
    "item": null,
    "species": [
      {
        "name": "togedemaru",
        "order": 777,
        "types": [
          PokeType.ELECTRIC,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 147,
    "ability_power": 150
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
